module.exports = __webpack_public_path__ + "static/img/img-instreg-mainbody.9894f61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/instreg/img-instreg-mainbody.png
// module id = zJtH
// module chunks = 1